import { axios } from '@lib/axios';

const BASE_URL = '/api/pacs';

export class PacsApi {
    public static async getShareLink(path: string): Promise<string> {
        const res = await axios.post(`${BASE_URL}/share`, { path });

        return res.data.url;
    }
}
